import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { VisuallyHidden } from '@react-aria/visually-hidden';
import IconStar from '../../icons/icon-star.svg';


class StarRating extends Component {
  render() {
    const {
      range, value, count, link, linkCTA,
    } = this.props;

    if (!value || !count) {
      return '';
    }

    const maxPercent = 100;
    const percentRating = Math.ceil(value / range * maxPercent);
    const ratingStyle = { width: `${percentRating}%` };

    return (
      <div className="star-rating">
        <VisuallyHidden>
          {`${value} out of 5 stars`}
        </VisuallyHidden>
        <div className="star-rating__stars">
          <div className="star-rating__base">
            {
            [...Array(range).keys()].map(star => (
              <IconStar key={star} className="star-rating__star" />
            ))
          }
          </div>
          <div className="star-rating__rate" style={ratingStyle}>
            {
            [...Array(range).keys()].map(star => (
              <IconStar key={star} className="star-rating__star star-rating__star--filled" />
            ))
          }
          </div>
        </div>
        { linkCTA && (
          <a className="star-rating__count" href={link}>{linkCTA}</a>
        )}
      </div>
    );
  }
}


StarRating.propTypes = {
  range: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
  count: PropTypes.number.isRequired,
  link: PropTypes.string,
  linkCTA: PropTypes.string,
};

StarRating.defaultProps = {
  link: null,
  linkCTA: null,
};

export default StarRating;
